import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  max-width: ${({ theme }) => theme.vars.stepsImageMaxWidthDM};
  height: ${({ theme }) => theme.vars.stepsImageMaxHeight};

  // TABLET
  ${({ theme }) => theme.media.tablet} {
    max-width: ${({ theme }) => theme.vars.stepsImageMaxWidthT};
    height: auto;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
